export default __webpack_public_path__ + "../staticImages/android-chrome-192x192.png";